/**
 * Labstep
 *
 * @module models/entity
 * @desc Typescript export class for any entity
 */

import { Link } from 'labstep-web/components/Layout/Links/types';
import { ICONS } from 'labstep-web/constants/icons';
import { humanReadableDate } from 'labstep-web/services/date.service';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';

interface IPermissions {
  edit: boolean;
  view: boolean;
  owner: boolean;
}

export class Entity {
  public static entityName: string;

  public static readonly idAttr: string = 'id';

  protected name!: string | null;

  public id!: string | number;

  guid!: string;

  created_at!: string;

  updated_at!: string;

  deleted_at!: string;

  permissions!: IPermissions;

  permission_entity_info!: null | {
    entityName: string;
    id: string | number;
  };

  lock_entity_info!: null | {
    entityName: string;
    id: string | number;
  };

  constructor(data: Partial<Entity> = {}) {
    Object.assign(this, data);
  }

  get entityName(): string {
    return 'entity';
  }

  public get idAttr(): string | number {
    return this[
      (this.constructor as typeof Entity).idAttr as 'id' | 'guid'
    ];
  }

  get displayName(): string | null {
    return this.name;
  }

  get printDeletedAtDate() {
    if (!this.deleted_at) {
      return '';
    }
    return `deleted on ${humanReadableDate(this.deleted_at)}`;
  }

  static getHumanReadableEntityName(
    plural?: boolean,
    capitalized?: boolean,
  ): string {
    return getHumanReadableEntityName(
      this.entityName,
      plural,
      capitalized,
    );
  }

  get entityIcon() {
    if (ICONS[this.entityName as keyof typeof ICONS].primary) {
      return ICONS[this.entityName as keyof typeof ICONS].primary;
    }
    return null;
  }

  get route(): Link['route'] | null {
    // FIXME Refactor into a router service helper
    // if (this.entityName === ExperimentWorkflow.entityName) {
    //   return {
    //     to: 'experiment_workflow_show',
    //     params: {
    //       id: this.id,
    //     },
    //   };
    // }
    return null;
  }
}
